import {z} from 'zod';

import {
  TelephonyGroup,
  TelephonyGroupRequestBody,
  TelephonyGroupRingStrategySchema,
} from '@dms/api/settings';

const GROUP_NAME_MAX_LENGTH = 255;
export const RING_SECONDS_MIN = 5;
export const RING_SECONDS_MAX = 120;
const RING_SECONDS_DEFAULT = 20;

export const telephonyGroupFormSchema = z.object({
  name: z.string().trim().min(1).max(GROUP_NAME_MAX_LENGTH),
  ringStrategy: TelephonyGroupRingStrategySchema,
  ringSeconds: z.number().int().min(RING_SECONDS_MIN).max(RING_SECONDS_MAX),
  memberUserIds: z.array(z.string()),
});

export type TelephonyGroupFormValues = z.infer<typeof telephonyGroupFormSchema>;

export const EMPTY_TELEPHONY_GROUP_FORM_VALUES: TelephonyGroupFormValues = {
  name: '',
  ringStrategy: 'simultaneous',
  ringSeconds: RING_SECONDS_DEFAULT,
  memberUserIds: [],
};

export const getTelephonyGroupFormValues = (group: TelephonyGroup): TelephonyGroupFormValues => ({
  name: group.name,
  ringStrategy: group.ringStrategy,
  ringSeconds: group.ringSeconds,
  memberUserIds: group.memberUserIds,
});

export const getTelephonyGroupRequestBody = (
  values: TelephonyGroupFormValues
): TelephonyGroupRequestBody => ({
  name: values.name,
  ringStrategy: values.ringStrategy,
  ringSeconds: values.ringSeconds,
  memberUserIds: values.memberUserIds,
});
